<template>
    <div id="mc_embed_signup">
        <form
            action="https://centracom.us14.list-manage.com/subscribe/post?u=3ed22f22af73ac74be8fd9c73&amp;id=e8166e629e"
            method="post"
            id="mc-embedded-subscribe-form"
            name="mc-embedded-subscribe-form"
            class="validate"
            target="_blank"
            novalidate
        >
            <div id="mc_embed_signup_scroll">
                <h2>Receive Notification About Events</h2>
                <div class="indicates-required">
                    <span class="asterisk">*</span> indicates required
                </div>
                <div class="mc-field-group">
                    <label for="mce-EMAIL">
                        Email Address <span class="asterisk">*</span>
                    </label>
                    <input
                        type="email"
                        value=""
                        name="EMAIL"
                        class="required email"
                        id="mce-EMAIL"
                    />
                </div>
                <div class="mc-field-group">
                    <label for="mce-FNAME">First Name </label>
                    <input type="text" value="" name="FNAME" class="" id="mce-FNAME" />
                </div>
                <div class="mc-field-group">
                    <label for="mce-LNAME">Last Name </label>
                    <input type="text" value="" name="LNAME" class="" id="mce-LNAME" />
                </div>
                <div class="mc-field-group">
                    <label for="mce-MMERGE11">Zip Code </label>
                    <input
                        type="text"
                        value=""
                        name="MMERGE11"
                        class=""
                        id="mce-MMERGE11"
                    />
                </div>
                <div hidden="true">
                    <input type="hidden" name="tags" value="7274873" />
                </div>
                <div id="mce-responses" class="clear">
                    <div
                        class="response"
                        id="mce-error-response"
                        style="display: none"
                    ></div>
                    <div
                        class="response"
                        id="mce-success-response"
                        style="display: none"
                    ></div>
                </div>
                <!-- real people should not fill this in and expect good things - do not remove this or risk form bot signups-->
                <div style="position: absolute; left: -5000px" aria-hidden="true">
                    <input
                        type="text"
                        name="b_3ed22f22af73ac74be8fd9c73_e8166e629e"
                        tabindex="-1"
                        value=""
                    />
                </div>
                <div class="clear">
                    <input
                        type="submit"
                        value="Subscribe"
                        name="subscribe"
                        id="mc-embedded-subscribe"
                        class="button"
                    />
                </div>
            </div>
        </form>
    </div>
</template>

<script>
export default {
    data: () => ({

    }),
    methods: {
        loadMailchimpScript() {
            if (!document.getElementById('mailchimpScript')) {
                const script = document.createElement('script');
                script.src = '//s3.amazonaws.com/downloads.mailchimp.com/js/mc-validate.js';
                script.id = 'mailchimpScript';
                document.head.appendChild(script);
            }
        },
    },
    created() {
        this.loadMailchimpScript();

        window.fnames = new Array();
        window.ftypes = new Array();
        window.fnames[0] = 'EMAIL';
        window.ftypes[0] = 'email';
        window.fnames[1] = 'FNAME';
        window.ftypes[1] = 'text';
        window.fnames[2] = 'LNAME';
        window.ftypes[2] = 'text';
        window.fnames[3] = 'ADDRESS';
        window.ftypes[3] = 'address';
        window.fnames[4] = 'PHONE';
        window.ftypes[4] = 'phone';
        window.fnames[5] = 'BIRTHDAY';
        window.ftypes[5] = 'birthday';
        window.fnames[6] = 'MMERGE6';
        window.ftypes[6] = 'text';
        window.fnames[7] = 'MMERGE7';
        window.ftypes[7] = 'text';
        window.fnames[8] = 'MMERGE8';
        window.ftypes[8] = 'text';
        window.fnames[9] = 'MMERGE9';
        window.ftypes[9] = 'text';
        window.fnames[10] = 'MMERGE10';
        window.ftypes[10] = 'text';
        window.fnames[11] = 'MMERGE11';
        window.ftypes[11] = 'zip';
    },
};

</script>

<style scoped>
@import url('//cdn-images.mailchimp.com/embedcode/classic-10_7.css');

#mc_embed_signup {
    margin-left: auto;
    margin-right: auto;
    font: 14px Helvetica, Arial, sans-serif;
    width: 600px;
}
input {
    color: #fff;
}
</style>